import React from 'react';
import Loadable from 'react-loadable'

import CodeEditors from './views/Editors/CodeEditors'
import DefaultLayout from './containers/DefaultLayout';

function Loading() {
  return <div>Loading...</div>;
}

const ChangePassword = Loadable({
  loader: () => import('./views/ChangePassword/ChangePassword'),
  loading: Loading,
});

const Admins = Loadable({
  loader: () => import('./views/Admins/Admins'),
  loading: Loading,
});

const Admin = Loadable({
  loader: () => import('./views/Admins/Admin'),
  loading: Loading,
});

const ArtsozaiiUser = Loadable({
  loader: () => import('./views/ArtsozaiiUser/ArtsozaiiUser'),
  loading: Loading,
});

const CreatorApplications = Loadable({
  loader: () => import('./views/CreatorApplications/CreatorApplications'),
  loading: Loading,
});

const CreatorApplication = Loadable({
  loader: () => import('./views/CreatorApplications/CreatorApplication'),
  loading: Loading,
});

const Creators = Loadable({
  loader: () => import('./views/Creators/Creators'),
  loading: Loading,
});

const Creator = Loadable({
  loader: () => import('./views/Creators/Creator'),
  loading: Loading,
});

const CreatorPaidPasses = Loadable({
  loader: () => import('./views/Creators/CreatorPaidPasses'),
  loading: Loading,
});

const PaidPasses = Loadable({
  loader: () => import('./views/PaidPasses/PaidPasses'),
  loading: Loading,
});

const PaidPass = Loadable({
  loader: () => import('./views/PaidPasses/PaidPass'),
  loading: Loading,
});

const StampBooks = Loadable({
  loader: () => import('./views/StampBooks/StampBooks'),
  loading: Loading,
});

const StampBook = Loadable({
  loader: () => import('./views/StampBooks/StampBook'),
  loading: Loading,
});

const Stamp = Loadable({
  loader: () => import('./views/StampBooks/Stamp'),
  loading: Loading,
});

const Beacons = Loadable({
  loader: () => import('./views/Beacons/Beacons'),
  loading: Loading,
});

const Beacon = Loadable({
  loader: () => import('./views/Beacons/Beacon'),
  loading: Loading,
});

const BeaconEvent = Loadable({
  loader: () => import('./views/Beacons/BeaconEvent'),
  loading: Loading,
});

const Stories = Loadable({
  loader: () => import('./views/Stories/Stories'),
  loading: Loading,
});

const Story = Loadable({
  loader: () => import('./views/Stories/Story'),
  loading: Loading,
});

const StoryLanguageVariants = Loadable({
  loader: () => import('./views/Stories/StoryLanguageVariants'),
  loading: Loading,
});

const StoryHTMLEdit = Loadable({
  loader: () => import('./views/Stories/StoryHTML'),
  loading: Loading,
});

const StoryTourExtension = Loadable({
  loader: () => import('./views/Stories/StoryTourExtension'),
  loading: Loading,
});

const StoryAudioExtension = Loadable({
  loader: () => import('./views/Stories/StoryAudioExtension'),
  loading: Loading,
});

const Tags = Loadable({
  loader: () => import('./views/Tags/Tags'),
  loading: Loading,
});

const Tag = Loadable({
  loader: () => import('./views/Tags/Tag'),
  loading: Loading,
});

const Categories = Loadable({
  loader: () => import('./views/Categories/Categories'),
  loading: Loading,
});

const Category = Loadable({
  loader: () => import('./views/Categories/Category'),
  loading: Loading,
});

const CategoryStories = Loadable({
  loader: () => import('./views/Categories/CategoryStories'),
  loading: Loading,
});

const CategoryEvents = Loadable({
  loader: () => import('./views/Categories/CategoryEvents'),
  loading: Loading,
});

const Events = Loadable({
  loader: () => import('./views/Events/Events'),
  loading: Loading,
});

const Event = Loadable({
  loader: () => import('./views/Events/Event'),
  loading: Loading,
});

const EventCollectionStories = Loadable({
  loader: () => import('./views/Events/EventCollectionStories'),
  loading: Loading,
});

const EventNotices = Loadable({
  loader: () => import('./views/Events/EventNotices'),
  loading: Loading,
});

const Bundles = Loadable({
  loader: () => import('./views/Bundles/Bundles'),
  loading: Loading,
});

const Bundle = Loadable({
  loader: () => import('./views/Bundles/Bundle'),
  loading: Loading,
});

const BundleStories = Loadable({
  loader: () => import('./views/Bundles/BundleStories'),
  loading: Loading,
});

const PriceTiers = Loadable({
  loader: () => import('./views/PriceTiers/PriceTiers'),
  loading: Loading,
});

const PriceTier = Loadable({
  loader: () => import('./views/PriceTiers/PriceTier'),
  loading: Loading,
});

const Coupons = Loadable({
  loader: () => import('./views/Coupons/Coupons'),
  loading: Loading,
});

const Coupon = Loadable({
  loader: () => import('./views/Coupons/Coupon'),
  loading: Loading,
});

const CouponPurchases = Loadable({
  loader: () => import('./views/Coupons/CouponPurchases'),
  loading: Loading,
});

const CouponStories = Loadable({
  loader: () => import('./views/Coupons/CouponStories'),
  loading: Loading,
});

const CouponPaidPasses = Loadable({
  loader: () => import('./views/Coupons/CouponPaidPasses'),
  loading: Loading,
});

const Feedbacks = Loadable({
  loader: () => import('./views/Feedbacks/Feedbacks'),
  loading: Loading,
});

const Feedback = Loadable({
  loader: () => import('./views/Feedbacks/Feedback'),
  loading: Loading,
});

const CreatorSales = Loadable({
  loader: () => import('./views/Billing/CreatorSales/CreatorSales'),
  loading: Loading,
});

const CreatorSale = Loadable({
  loader: () => import('./views/Billing/CreatorSales/CreatorSale'),
  loading: Loading,
});

const CreatorBills = Loadable({
  loader: () => import('./views/Billing/CreatorBills/CreatorBills'),
  loading: Loading,
});

const CreatorBill = Loadable({
  loader: () => import('./views/Billing/CreatorBills/CreatorBill'),
  loading: Loading,
});

const CreatorPayments = Loadable({
  loader: () => import('./views/Billing/CreatorPayments/CreatorPayments'),
  loading: Loading,
});

const CreatorPayment = Loadable({
  loader: () => import('./views/Billing/CreatorPayments/CreatorPayment'),
  loading: Loading,
});

const PushNotifAnnouncements = Loadable({
  loader: () => import('./views/PushNotifAnnouncements/PushNotifAnnouncements'),
  loading: Loading,
});

const PushNotifAnnouncement  = Loadable({
  loader: () => import('./views/PushNotifAnnouncements/PushNotifAnnouncement'),
  loading: Loading,
});

const MediaUpload = Loadable({
  loader: () => import('./views/Media/Upload'),
  loading: Loading,
});

const ConfigTapPay = Loadable({
  loader: () => import('./views/Configs/ConfigTapPay'),
  loading: Loading,
});





const Compose = Loadable({
  loader: () => import('./views/Apps/Email/Compose'),
  loading: Loading,
});

const Inbox = Loadable({
  loader: () => import('./views/Apps/Email/Inbox'),
  loading: Loading,
});

const Message = Loadable({
  loader: () => import('./views/Apps/Email/Message'),
  loading: Loading,
});

const Invoice = Loadable({
  loader: () => import('./views/Apps/Invoicing/Invoice'),
  loading: Loading,
});

const Breadcrumbs = Loadable({
  loader: () => import('./views/Base/Breadcrumbs'),
  loading: Loading,
});

const Cards = Loadable({
  loader: () => import('./views/Base/Cards'),
  loading: Loading,
});

const Carousels = Loadable({
  loader: () => import('./views/Base/Carousels'),
  loading: Loading,
});

const Collapses = Loadable({
  loader: () => import('./views/Base/Collapses'),
  loading: Loading,
});

const Dropdowns = Loadable({
  loader: () => import('./views/Base/Dropdowns'),
  loading: Loading,
});

const Jumbotrons = Loadable({
  loader: () => import('./views/Base/Jumbotrons'),
  loading: Loading,
});

const ListGroups = Loadable({
  loader: () => import('./views/Base/ListGroups'),
  loading: Loading,
});

const Navbars = Loadable({
  loader: () => import('./views/Base/Navbars'),
  loading: Loading,
});

const Navs = Loadable({
  loader: () => import('./views/Base/Navs'),
  loading: Loading,
});

const Paginations = Loadable({
  loader: () => import('./views/Base/Paginations'),
  loading: Loading,
});

const Popovers = Loadable({
  loader: () => import('./views/Base/Popovers'),
  loading: Loading,
});

const ProgressBar = Loadable({
  loader: () => import('./views/Base/ProgressBar'),
  loading: Loading,
});

const Switches = Loadable({
  loader: () => import('./views/Base/Switches'),
  loading: Loading,
});

const Tabs = Loadable({
  loader: () => import('./views/Base/Tabs'),
  loading: Loading,
});

const Tooltips = Loadable({
  loader: () => import('./views/Base/Tooltips'),
  loading: Loading,
});

const BrandButtons = Loadable({
  loader: () => import('./views/Buttons/BrandButtons'),
  loading: Loading,
});

const ButtonDropdowns = Loadable({
  loader: () => import('./views/Buttons/ButtonDropdowns'),
  loading: Loading,
});

const ButtonGroups = Loadable({
  loader: () => import('./views/Buttons/ButtonGroups'),
  loading: Loading,
});

const Buttons = Loadable({
  loader: () => import('./views/Buttons/Buttons'),
  loading: Loading,
});

const LoadingButtons = Loadable({
  loader: () => import('./views/Buttons/LoadingButtons'),
  loading: Loading,
});

const Charts = Loadable({
  loader: () => import('./views/Charts'),
  loading: Loading,
});

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

// issue with mispalced position of cm value for acync load
// const CodeEditors = Loadable({
//   loader: () => import('./views/Editors/CodeEditors'),
//   loading: Loading,
// });

const TextEditors = Loadable({
  loader: () => import('./views/Editors/TextEditors'),
  loading: Loading,
});


const AdvancedForms = Loadable({
  loader: () => import('./views/Forms/AdvancedForms'),
  loading: Loading,
});

const BasicForms = Loadable({
  loader: () => import('./views/Forms/BasicForms'),
  loading: Loading,
});

const GoogleMaps = Loadable({
  loader: () => import('./views/GoogleMaps'),
  loading: Loading,
});

const CoreUIIcons = Loadable({
  loader: () => import('./views/Icons/CoreUIIcons'),
  loading: Loading,
});

const Flags = Loadable({
  loader: () => import('./views/Icons/Flags'),
  loading: Loading,
});

const FontAwesome = Loadable({
  loader: () => import('./views/Icons/FontAwesome'),
  loading: Loading,
});

const SimpleLineIcons = Loadable({
  loader: () => import('./views/Icons/SimpleLineIcons'),
  loading: Loading,
});

const Alerts = Loadable({
  loader: () => import('./views/Notifications/Alerts'),
  loading: Loading,
});

const Badges = Loadable({
  loader: () => import('./views/Notifications/Badges'),
  loading: Loading,
});

const Modals = Loadable({
  loader: () => import('./views/Notifications/Modals'),
  loading: Loading,
});

const Toastr = Loadable({
  loader: () => import('./views/Notifications/Toastr'),
  loading: Loading,
});

const Calendar = Loadable({
  loader: () => import('./views/Plugins/Calendar'),
  loading: Loading,
});

const Draggable = Loadable({
  loader: () => import('./views/Plugins/Draggable'),
  loading: Loading,
});

const Spinners = Loadable({
  loader: () => import('./views/Plugins/Spinners'),
  loading: Loading,
});

const DataTable = Loadable({
  loader: () => import('./views/Tables/DataTable'),
  loading: Loading,
});

const Tables = Loadable({
  loader: () => import('./views/Tables/Tables'),
  loading: Loading,
});

const Colors = Loadable({
  loader: () => import('./views/Theme/Colors'),
  loading: Loading,
});

const Typography = Loadable({
  loader: () => import('./views/Theme/Typography'),
  loading: Loading,
});

// const Widgets = Loadable({
//   loader: () => import('./views/Widgets/Widgets'),
//   loading: Loading,
// });

const Users = Loadable({
  loader: () => import('./views/Users/Users'),
  loading: Loading,
});

const User = Loadable({
  loader: () => import('./views/Users/User'),
  loading: Loading,
});

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', name: 'Home', component: DefaultLayout, exact: true },
  { path: '/change-password', name: 'Change Password', component: ChangePassword, exact: true },
  { path: '/admins', name: 'Admin Users', component: Admins, exact: true },
  { path: '/admins/:id', name: 'Admin', component: Admin, exact: true },
  { path: '/artsozaii-users/:id', name: 'Artsozaii User', component: ArtsozaiiUser, exact: true },
  { path: '/creator-applications', name: 'Creator Applications', component: CreatorApplications, exact: true },
  { path: '/creator-applications/:id', name: 'Creator Application', component: CreatorApplication, exact: true },
  { path: '/creators', name: 'Creators', component: Creators, exact: true },
  { path: '/creators/:id', name: 'Creator', component: Creator, exact: true },
  { path: '/creators/:creatorId/paid-passes', name: 'Creator Paid Passes', component: CreatorPaidPasses, exact: true },
  { path: '/paid-passes', name: 'Paid Passes', component: PaidPasses, exact: true },
  { path: '/paid-passes/:id', name: 'Paid Pass', component: PaidPass, exact: true },
  { path: '/stamp-books', name: 'Stamp Books', component: StampBooks, exact: true },
  { path: '/stamp-books/:id', name: 'Stamp Book', component: StampBook, exact: true },
  { path: '/stamp-books/:stampBookId/stamps/:id', name: 'Stamp', component: Stamp, exact: true },
  { path: '/beacons', name: 'Beacons', component: Beacons, exact: true },
  { path: '/beacons/:id', name: 'Beacon', component: Beacon, exact: true },
  { path: '/beacons/:beaconId/events/:id', name: 'Beacon Event', component: BeaconEvent, exact: true },
  { path: '/stories', name: 'Stories', component: Stories, exact: true },
  { path: '/stories/:id', name: 'Story', component: Story, exact: true },
  { path: '/stories/:id/language-variants', name: 'Language Variants', component: StoryLanguageVariants, exact: true },
  { path: '/stories/:id/edit-html', name: 'Edit Story HTML', component: StoryHTMLEdit, exact: true },
  { path: '/stories/:id/extensions/tour', name: 'Edit Story Tour Extension', component: StoryTourExtension, exact: true },
  { path: '/stories/:id/extensions/audio', name: 'Edit Story Audio Extension', component: StoryAudioExtension, exact: true },
  { path: '/tags', name: 'Tags', component: Tags, exact: true },
  { path: '/tags/:id', name: 'Tag', component: Tag, exact: true },
  { path: '/categories', name: 'Categories', component: Categories, exact: true },
  { path: '/categories/:id', name: 'Category', component: Category, exact: true },
  { path: '/categories/:categoryId/stories', name: 'Category Stories', component: CategoryStories, exact: true },
  { path: '/categories/:categoryId/events', name: 'Category Events', component: CategoryEvents, exact: true },
  { path: '/events', name: 'Events', component: Events, exact: true },
  { path: '/events/:id', name: 'Event', component: Event, exact: true },
  { path: '/events/:eventId/collections/:collection/stories', name: 'Event Collection Stories', component: EventCollectionStories, exact: true },
  { path: '/events/:eventId/notices', name: 'Event Notices', component: EventNotices, exact: true },
  { path: '/bundles', name: 'Bundles', component: Bundles, exact: true },
  { path: '/bundles/:id', name: 'Bundle', component: Bundle, exact: true },
  { path: '/bundles/:bundleId/stories', name: 'Bundle Stories', component: BundleStories, exact: true },
  { path: '/price-tiers', name: 'Price Tiers', component: PriceTiers, exact: true },
  { path: '/price-tiers/:id', name: 'Price Tier', component: PriceTier, exact: true },
  { path: '/coupons', name: 'Coupons', component: Coupons, exact: true },
  { path: '/coupons/:id', name: 'Coupon', component: Coupon, exact: true },
  { path: '/coupons/:id/purchases', name: 'Redeem Records', component: CouponPurchases, exact: true },
  { path: '/coupons/:couponId/stories', name: 'Coupon Stories', component: CouponStories, exact: true },
  { path: '/coupons/:couponId/paid-passes', name: 'Coupon Paid Passes', component: CouponPaidPasses, exact: true },
  { path: '/feedbacks', name: 'Feedbacks', component: Feedbacks, exact: true },
  { path: '/feedbacks/:id', name: 'Feedback', component: Feedback, exact: true },
  { path: '/billing/creator-sales', name: 'Creator Sales', component: CreatorSales, exact: true },
  { path: '/billing/creator-sales/:id', name: 'Creator Sale', component: CreatorSale, exact: true },
  { path: '/billing/creator-bills', name: 'Creator Bills', component: CreatorBills, exact: true },
  { path: '/billing/creator-bills/:id', name: 'Creator Bill', component: CreatorBill, exact: true },
  { path: '/billing/creator-payments', name: 'Creator Payments', component: CreatorPayments, exact: true },
  { path: '/billing/creator-payments/:id', name: 'Creator Payment', component: CreatorPayment, exact: true },
  { path: '/push-announcements', name: 'Push Announcements', component: PushNotifAnnouncements, exact: true },
  { path: '/push-announcements/:id', name: 'Push Announcement', component: PushNotifAnnouncement, exact: true },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/media/upload', name: 'Media Upload', component: MediaUpload, exact: true },
  { path: '/configs/tappay', name: 'TapPay Config', component: ConfigTapPay, exact: true },


  { path: '/theme', name: 'Theme', component: Colors, exact: true },
  { path: '/theme/colors', name: 'Colors', component: Colors },
  { path: '/theme/typography', name: 'Typography', component: Typography },
  { path: '/base', name: 'Base', component: Cards, exact: true },
  { path: '/base/breadcrumbs', name: 'Breadcrumbs', component: Breadcrumbs },
  { path: '/base/cards', name: 'Cards', component: Cards },
  { path: '/base/carousels', name: 'Carousel', component: Carousels },
  { path: '/base/collapses', name: 'Collapse', component: Collapses },
  { path: '/base/dropdowns', name: 'Dropdowns', component: Dropdowns },
  { path: '/base/jumbotrons', name: 'Jumbotrons', component: Jumbotrons },
  { path: '/base/list-groups', name: 'List Groups', component: ListGroups },
  { path: '/base/navbars', name: 'Navbars', component: Navbars },
  { path: '/base/navs', name: 'Navs', component: Navs },
  { path: '/base/paginations', name: 'Paginations', component: Paginations },
  { path: '/base/popovers', name: 'Popovers', component: Popovers },
  { path: '/base/progress-bar', name: 'Progress Bar', component: ProgressBar },
  { path: '/base/switches', name: 'Switches', component: Switches },
  { path: '/base/tabs', name: 'Tabs', component: Tabs },
  { path: '/base/tooltips', name: 'Tooltips', component: Tooltips },
  { path: '/buttons', name: 'Buttons', component: Buttons, exact: true },
  { path: '/buttons/buttons', name: 'Buttons', component: Buttons },
  { path: '/buttons/button-dropdowns', name: 'Dropdowns', component: ButtonDropdowns },
  { path: '/buttons/button-groups', name: 'Button Groups', component: ButtonGroups },
  { path: '/buttons/brand-buttons', name: 'Brand Buttons', component: BrandButtons },
  { path: '/buttons/loading-buttons', name: 'Loading Buttons', component: LoadingButtons },
  { path: '/charts', name: 'Charts', component: Charts },
  { path: '/editors', name: 'Editors', component: CodeEditors, exact: true },
  { path: '/editors/code-editors', name: 'Code Editors', component: CodeEditors },
  { path: '/editors/text-editors', name: 'Text Editors', component: TextEditors },
  { path: '/forms', name: 'Forms', component: BasicForms, exact: true },
  { path: '/forms/advanced-forms', name: 'Advanced Forms', component: AdvancedForms },
  { path: '/forms/basic-forms', name: 'Basic Forms', component: BasicForms },
  { path: '/google-maps', name: 'Google Maps', component: GoogleMaps },
  { path: '/icons', exact: true, name: 'Icons', component: CoreUIIcons },
  { path: '/icons/coreui-icons', name: 'CoreUI Icons', component: CoreUIIcons },
  { path: '/icons/flags', name: 'Flags', component: Flags },
  { path: '/icons/font-awesome', name: 'Font Awesome', component: FontAwesome },
  { path: '/icons/simple-line-icons', name: 'Simple Line Icons', component: SimpleLineIcons },
  { path: '/notifications', name: 'Notifications', component: Alerts, exact: true },
  { path: '/notifications/alerts', name: 'Alerts', component: Alerts },
  { path: '/notifications/badges', name: 'Badges', component: Badges },
  { path: '/notifications/modals', name: 'Modals', component: Modals },
  { path: '/notifications/toastr', name: 'Toastr', component: Toastr },
  { path: '/plugins', name: 'Plugins', component: Calendar, exact: true },
  { path: '/plugins/calendar', name: 'Calendar', component: Calendar },
  { path: '/plugins/draggable', name: 'Draggable Cards', component: Draggable },
  { path: '/plugins/spinners', name: 'Spinners', component: Spinners },
  { path: '/tables', name: 'Tables', component: Tables, exact: true },
  { path: '/tables/data-table', name: 'Data Table', component: DataTable },
  { path: '/tables/tables', name: 'Tables', component: Tables },
  { path: '/apps', name: 'Apps', component: Compose, exact: true },
  { path: '/apps/email', name: 'Email', component: Compose, exact: true },
  { path: '/apps/email/compose', name: 'Compose', component: Compose },
  { path: '/apps/email/inbox', name: 'Inbox', component: Inbox },
  { path: '/apps/email/message', name: 'Message', component: Message },
  { path: '/apps/invoicing', name: 'Invoice', component: Invoice, exact: true },
  { path: '/apps/invoicing/invoice', name: 'Invoice', component: Invoice },
  { path: '/users', exact: true,  name: 'Users', component: Users },
  { path: '/users/:id', exact: true, name: 'User Details', component: User }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js